import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../component/login/login.component';
import { AuthGuard } from '../injectable/auth/auth.guard';
import { ShowMessageComponent } from '../component/show-message/show-message.component';
import { ResetPasswordComponent } from '../component/reset-password/reset-password.component';
import { ChangePasswordComponent } from '../component/change-password/change-password.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { DistributionListComponent } from '../component/distribution-list/distribution-list.component';
import { RefreshComponent } from '../component/refresh/refresh.component';
import { AreaSearchComponent } from '../component/area-search/area-search.component';
import { ShowClientsComponent } from '../component/show-clients/show-clients.component';
import { ClientDetailComponent } from '../component/client-detail/client-detail.component';
import { ShowUsersComponent } from '../component/show-users/show-users.component';
import { ShowAreasComponent } from '../component/show-areas/show-areas.component';
import { AreaDrawComponent } from '../component/area-draw/area-draw.component';
import { AreaInsertComponent } from '../component/area-insert/area-insert.component';
import { ShowServicesComponent } from '../component/show-services/show-services.component';
import { InsertServiceComponent } from '../component/insert-service/insert-service.component';
import { ContactsComponent } from '../component/contacts/contacts.component';
import { MessageDetailComponent } from '../component/message-detail/message-detail.component';
import { ModifyServiceComponent } from '../component/modify-service/modify-service.component';

const routes: Routes = [
  { path: 'dboard', loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },
  { path: 'contacts', component: ContactsComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [AuthGuard] },
  { path: 'messages', component: ShowMessageComponent, canActivate: [AuthGuard] },
  { path: 'messages/:id', component: MessageDetailComponent, canActivate: [AuthGuard] },
  { path: 'clients', component: ShowClientsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:id', component: ClientDetailComponent, canActivate: [AuthGuard] },
  { path: 'users', component: ShowUsersComponent, canActivate: [AuthGuard] },
  { path: 'areas', component: ShowAreasComponent, canActivate: [AuthGuard] },
  { path: 'areas/insert', component: AreaInsertComponent, canActivate: [AuthGuard] },
  { path: 'refreshComponent', component: RefreshComponent, canActivate: [AuthGuard] },
  { path: 'distribution-list', component: DistributionListComponent, canActivate: [AuthGuard] },
  // { path: 'distribution-list-users/:id', component: DistributionListUsersComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/messages', pathMatch: 'full' },
  { path: 'area-search', component: AreaSearchComponent },
  { path: 'area-draw', component: AreaDrawComponent },
  { path: 'services', component: ShowServicesComponent, canActivate: [AuthGuard] },
  { path: 'services/insert', component: InsertServiceComponent, canActivate: [AuthGuard] },
  { path: 'services/:id', component: ModifyServiceComponent, canActivate: [AuthGuard] },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }